import React from 'react';
import classNames from 'classnames';

import css from './IconClip.module.css';

const IconClip = ({ className, rootClassName }) => (
  <svg
    className={classNames(rootClassName || css.root, className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.276 6C5.52585 3.61167 7.54552 1.75 10 1.75C12.6234 1.75 14.75 3.87665 14.75 6.5V15.25C14.75 16.9069 13.4069 18.25 11.75 18.25C10.0931 18.25 8.75 16.9069 8.75 15.25V6H10.25V15.25C10.25 16.0784 10.9216 16.75 11.75 16.75C12.5784 16.75 13.25 16.0784 13.25 15.25V6.5C13.25 4.70507 11.7949 3.25 10 3.25C8.20507 3.25 6.75 4.70507 6.75 6.5V15.75C6.75 18.5114 8.98858 20.75 11.75 20.75C14.5114 20.75 16.75 18.5114 16.75 15.75V6H18.25V15.75C18.25 19.3399 15.3399 22.25 11.75 22.25C8.16015 22.25 5.25 19.3399 5.25 15.75V6H5.276Z"
    />
  </svg>
);

export default IconClip;
